var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthAndFitness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.66 11.59a16.26 16.26 0 0 0-2.41.16 1.78 1.78 0 0 0-.5 0c-.18-.87 0-1.83-.6-2.36a.64.64 0 0 0-.75-.11 1.77 1.77 0 0 0-.75 1.32 16.18 16.18 0 0 1-.65 2.18c-.15-1.66-.34-4.48-1-5.11s-1.25-.07-1.57.8c-.38 1-.59 3-1.13 3.09a15 15 0 0 1-2.45 0 .3.3 0 1 0 0 .6c.71 0 2.78.47 3.26-.21a16.89 16.89 0 0 0 1.2-3.12c.09-.2 0-1.38.57 4.5.07.71 0 1.86.68 2.21a.64.64 0 0 0 .86-.3 8.17 8.17 0 0 0 .41-1.31c.24-1.05.66-2 .82-3.14l.07-.23c.12.79.17 2.08.86 2.12a23.73 23.73 0 0 1 3.09-.4.34.34 0 1 0-.01-.69Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89 3.28A4.8 4.8 0 0 1 7 2.47c.14-.8.14-.79.79-1 1.86-.62 4.4-.16 7.15-.29.72 0 2.35-.15 2.84.4.24.28 0 1.69.08 2.13a.35.35 0 0 0 .69 0C18.52 2 19.81.09 14.9.09 13.63.11 9.58-.39 7.26.8a1.4 1.4 0 0 0-.91 1.39 9 9 0 0 0-.07 1.11.31.31 0 0 0 .61-.02Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.64 21.3a5 5 0 0 1-.07.8c-.19.37-1.46.66-1.88.72-.66.09-4.16 0-5.54 0-.81.07-2.37.17-2.88-.48a2.25 2.25 0 0 1-.17-1.04c.05-1.9-.84-1.76-.75 0s.39 2.7 3.85 2.64c2.21-.1 5.23.51 7.38-.8.73-.45.85-.92.87-1.84 0-1.64-.95-2.03-.81 0Z",
    fill: "#B557F7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 15.51c0-10.18.08-8.62-.22-9.55S20 4.7 18.63 4.54C17 4.36 14 4.49 8.56 4.35a23.2 23.2 0 0 1-2.87.06C1.55 4 3.19 9.73 3.18 15.62c0 2.67.61 3.75 3.23 3.79 10.19-.45 14 1.26 14.65-1.82a6.5 6.5 0 0 0-.06-2.08Zm-.9 1.59c-.08.72-.39 1.2-1.47 1.29a15.54 15.54 0 0 1-1.82-.12H6.1c-1.63 0-1.77-1-1.79-2.66 0-2.52-.48-5.8-.29-8.61.08-1.16.43-1.85 1.59-1.75a24.4 24.4 0 0 0 3-.13c1.48 0 9.2-.07 10.3.16C20.6 5.64 20.17 7 20.06 12l0 3.53a7.36 7.36 0 0 1 .04 1.57Z",
    fill: "#8841B9",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthAndFitness);
export default __webpack_public_path__ + "static/media/health-and-fitness.e893c4b0ed3f542714dbb30c52c3bd1e.svg";
export { ForwardRef as ReactComponent };